// extracted by mini-css-extract-plugin
export default {"container":"style_container__LJNIT","card":"style_card__Qm9U3","cardIcon":"style_cardIcon__ypZyb","mainImg":"style_mainImg__ePmfV"};